import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React from 'react';
import { Base } from './Base';
import Portal from './portal';
export var show = function show(config) {
  var currentConfig = _objectSpread(_objectSpread({}, config), {}, {
    active: true
  });
  var currentModalKey = 0;
  var render = function render(props) {
    currentModalKey = Portal.add( /*#__PURE__*/React.createElement(Base, _extends({}, props, {
      active: true,
      renderByShow: true
    })));
  };
  var update = function update(configUpdate) {
    if (typeof configUpdate === 'function') {
      currentConfig = configUpdate(currentConfig);
    } else {
      currentConfig = _objectSpread(_objectSpread({}, currentConfig), configUpdate);
    }
    close();
    setTimeout(function () {
      render(currentConfig);
    });
  };
  var close = function close() {
    Portal.remove(currentModalKey);
  };
  render(currentConfig);
  return {
    update: update,
    destroy: close
  };
};